import { t } from 'i18next';
import { cn } from '../../../lib/styles';
import type { PlatformOption } from '../constants';

export function PlatformOptionRow({
  option,
  selected,
  disabled,
  onSelect,
}: {
  option: PlatformOption;
  selected: boolean;
  disabled: boolean;
  onSelect: () => void;
}) {
  const id = `platform-${option.key}`;

  return (
    <div className={cn('relative flex p-4', selected ? 'bg-indigo-50' : 'hover:bg-gray-50')}>
      <div className="flex h-5 items-center">
        <input
          type="radio"
          id={id}
          name="platform"
          value={option.key}
          checked={selected}
          disabled={disabled}
          onChange={onSelect}
          className="hidden size-4 cursor-pointer border-gray-300 text-indigo-600 focus:ring-indigo-500 disabled:pointer-events-none disabled:cursor-not-allowed"
        />
      </div>
      <span>
        <img
          src={option.logo}
          alt=""
          className={cn(
            'size-9 min-w-9 rounded-full border-2',
            selected ? 'border-indigo-700' : 'border-gray-300',
          )}
        />
      </span>
      <label
        htmlFor={id}
        className={cn(
          'ml-3 flex w-full flex-col',
          disabled && selected ? '' : disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        )}
      >
        <span
          className={cn(
            'block font-medium text-sm',
            selected ? 'text-indigo-700' : 'text-gray-900',
          )}
        >
          {t(option.nameKey)}
        </span>
        <span className={cn('block text-sm', selected ? 'text-indigo-700' : 'text-gray-500')}>
          {t(option.specificsKey)}
        </span>
      </label>
    </div>
  );
}
